// The practice's practice-management system (D208). Today's mock practice is Dentrix.
// `?pms=curve|opendental|ascend` swaps the name in all copy (mock only). It is read once at
// module load and kept in sessionStorage so in-app navigation keeps it; a reload with the
// param (or `?pms=dentrix`) resets it. Layouts must not change, only the word.

export type PmsKey = 'dentrix' | 'ascend' | 'curve' | 'opendental';

const NAMES: Record<PmsKey, string> = {
  dentrix: 'Dentrix',
  ascend: 'Dentrix Ascend',
  curve: 'Curve Dental',
  opendental: 'Open Dental',
};

const STORE_KEY = 'rcm.mock.pms';

function resolve(): PmsKey {
  try {
    const q = new URLSearchParams(window.location.search).get('pms')?.toLowerCase();
    if (q && q in NAMES) {
      window.sessionStorage.setItem(STORE_KEY, q);
      return q as PmsKey;
    }
    const kept = window.sessionStorage.getItem(STORE_KEY);
    if (kept && kept in NAMES) return kept as PmsKey;
  } catch {
    /* no window / storage: fall through */
  }
  return 'dentrix';
}

export const PMS_KEY: PmsKey = resolve();

/** The location's PMS name for copy, e.g. "Reference written to ${PMS} · check 004417820". */
export const PMS: string = NAMES[PMS_KEY];
